import { ReduxThunkType } from '../../types/ReduxThunkType';
import { Actions as NotificationActions } from './actions';
import NotificationsService from '../../services/NotificationsService';
import { RestErrorResponse } from '../../types/response/RestErrorResponse';
import { RequestNotificationType } from './types';
import { sortNotificationsByDate } from '../../../pages/components/header/header-notification/helpers';

export const getNotifications =
  (read: boolean): ReduxThunkType<void> =>
  async (dispatch) => {
    try {
      dispatch(NotificationActions.getNotifications());
      const response = await NotificationsService.getNotifications(read);
      dispatch(NotificationActions.getNotificationsSuccess(sortNotificationsByDate(response.data.content)));
    } catch (error) {
      dispatch(NotificationActions.getNotificationsError(error as RestErrorResponse));
    }
  };

export const getNotificationTypes = (): ReduxThunkType<void> => async (dispatch) => {
  try {
    dispatch(NotificationActions.getNotificationTypes());
    const response = await NotificationsService.getNotificationType();
    dispatch(NotificationActions.getNotificationTypesSuccess(response.data.content));
  } catch (error) {
    dispatch(NotificationActions.getNotificationTypesError(error as RestErrorResponse));
  }
};

export const saveNotificationType =
  (notificationTypes: RequestNotificationType[]): ReduxThunkType<void> =>
  async (dispatch) => {
    try {
      dispatch(NotificationActions.saveNotificationType());
      await Promise.all(
        notificationTypes.map(async (type) => {
          await NotificationsService.saveNotificationType(type);
        })
      );
      dispatch(NotificationActions.saveNotificationTypeSuccess());
    } catch (error) {
      dispatch(NotificationActions.saveNotificationTypeError(error as RestErrorResponse));
    }
  };
